/**
 * Thai render vocabulary.
 *
 * Self-registering: importing this module makes the words available to
 * `render(node, 'th')`. Kept separate from the profile so a parse-only
 * bundle can drop it — see lexicon-registry.ts for why that separation exists.
 */
import type { LanguageLexicon } from '../generators/profiles/types';
import { registerLexicon } from '../lexicon-registry';

export const thaiLexicon: LanguageLexicon = {
  events: {
    blur: { primary: 'เบลอ' },
    change: { primary: 'เปลี่ยนแปลง' },
    click: { primary: 'คลิก' },
    every: { primary: 'ทุก' },
    focus: { primary: 'โฟกัส' },
    input: { primary: 'อินพุต' },
    keydown: { primary: 'กดคีย์' },
    keyup: { primary: 'ปล่อยคีย์' },
    load: { primary: 'โหลด' },
    mouseout: { primary: 'เมาส์ออก' },
    mouseover: { primary: 'เมาส์เข้า' },
    reset: { primary: 'รีเซ็ต' },
    resize: { primary: 'ปรับขนาด' },
    scroll: { primary: 'เลื่อน' },
    submit: { primary: 'ส่ง' },
  },
  logical: {
    and: { primary: 'และ' },
    changes: { primary: 'เปลี่ยน' },
    else: { primary: 'ไม่งั้น' },
    empty: { primary: 'ว่าง' },
    end: { primary: 'จบ' },
    exists: { primary: 'มีอยู่' },
    false: { primary: 'เท็จ' },
    has: { primary: 'มี' },
    have: { primary: 'มี' },
    if: { primary: 'ถ้า' },
    is: { primary: 'เป็น' },
    live: { primary: 'สด' },
    not: { primary: 'ไม่' },
    null: { primary: 'null' },
    or: { primary: 'หรือ' },
    then: { primary: 'แล้ว' },
    true: { primary: 'จริง' },
    undefined: { primary: 'ไม่กำหนด' },
    when: { primary: 'เมื่อ' },
    where: { primary: 'ที่ไหน' },
  },
  temporal: {
    forever: { primary: 'ตลอดไป' },
    hours: { primary: 'ชั่วโมง' },
    milliseconds: { primary: 'มิลลิวินาที' },
    minutes: { primary: 'นาที' },
    ms: { primary: 'มว' },
    now: { primary: 'ตอนนี้' },
    s: { primary: 'วิ' },
    seconds: { primary: 'วินาที' },
    times: { primary: 'ครั้ง' },
  },
  values: {
    body: { primary: 'บอดี้' },
    event: { primary: 'เหตุการณ์' },
    it: { primary: 'มัน' },
    its: { primary: 'ของมัน' },
    me: { primary: 'ฉัน' },
    my: { primary: 'ของฉัน' },
    result: { primary: 'ผลลัพธ์' },
    target: { primary: 'เป้าหมาย' },
    you: { primary: 'คุณ' },
    your: { primary: 'ของคุณ' },
  },
  attributes: {
    checked: { primary: 'เลือกแล้ว' },
    class: { primary: 'คลาส' },
    disabled: { primary: 'ปิดใช้งาน' },
    html: { primary: 'เอชทีเอ็มแอล' },
    id: { primary: 'ไอดี' },
    style: { primary: 'สไตล์' },
    text: { primary: 'ข้อความ' },
    value: { primary: 'ค่า' },
  },
  expressions: {
    characters: { primary: 'อักขระ' },
    children: { primary: 'ลูก' },
    closest: { primary: 'ใกล้สุด' },
    empty: { primary: 'ล้าง' },
    'ends with': { primary: 'ลงท้ายด้วย' },
    exclusive: { primary: 'ยกเว้น' },
    first: { primary: 'แรก' },
    'ignoring case': { primary: 'ไม่สนตัวพิมพ์' },
    inclusive: { primary: 'รวม' },
    index: { primary: 'ดัชนี' },
    'joined by': { primary: 'รวมด้วย' },
    last: { primary: 'สุดท้าย' },
    length: { primary: 'ความยาว' },
    'mapped to': { primary: 'แปลงเป็น' },
    next: { primary: 'ถัดไป' },
    parent: { primary: 'ต้นทาง' },
    previous: { primary: 'ก่อนหน้า' },
    random: { primary: 'สุ่ม' },
    'sorted by': { primary: 'เรียงตาม' },
    'split by': { primary: 'แยกด้วย' },
    'starts with': { primary: 'ขึ้นต้นด้วย' },
  },
};

registerLexicon('th', thaiLexicon);
